import React, {Component} from 'react';
import "./AboutBrief.scss"
import AboutBriefImg02 from "../../static/img/AboutBrief-02.jpg"
import AboutBriefImg03 from "../../static/img/AboutBrief-03.png"

class AboutBrief extends Component {
    render() {
        return (
            <div className="AboutBrief">
                <div className="AboutBrief-tips">
                    <div className="title">
                        我们能做什么
                    </div>
                    <div className="text">
                        以先进的信息管理系统为平台、以现代物流技术为手段，构建综合运输网络和集货配送物流体系。 目前本公司已建立起以连云港为中心，辐射全国的物流网络。
                    </div>
                </div>
                <div className="AboutBrief-list">
                    <div className="item">
                        <div className="title">
                            全国
                        </div>
                        <div className="text">
                            业务分布<br/>
                            Business Scope
                        </div>
                    </div>
                    <div className="item">
                        <div className="title">
                            3<span>万</span>
                        </div>
                        <div className="text">
                            合作车辆船舶<br/>
                            vehicles and ships
                        </div>
                    </div>
                    <div className="item">
                        <div className="title">
                            6<span>万</span>
                        </div>
                        <div className="text">
                            合作司机车主<br/>
                            driver car owner
                        </div>
                    </div>
                    <div className="item">
                        <div className="title">
                            8<span>千万</span>
                        </div>
                        <div className="text">
                            货运累积量<br/>
                            Cumulative freight
                        </div>
                    </div>
                </div>
                <div className="AboutBrief-we">
                    <div className="content">
                        <div className="left">
                            <div className="title">
                                <div>
                                    关于我们
                                </div>
                                <div>
                                    About Us
                                </div>
                            </div>
                            <div className="text">
                            宜兴市交运物流信息科技有限公司，是一家专业从事物流行业网络货运服务的现代化物流科技公司，企业服务网络覆盖全国，是中国“网络货运”行业的新星企业。
                            </div>
                            <div className="text">
                            公司成立于2018年，以先进的信息管理系统为平台、以现代物流技术为手段，构建综合运输网络和集货配送物流体系。目前本公司已建立起以宜兴市为中心，辐射全国的物流网络。一直以客户为中心，关注客户需求追求完美服务，具有绝对优势的输运经验。
                            </div>
                        </div>
                        <div className="right">
                            <img src={AboutBriefImg02} alt=""/>
                        </div>
                    </div>
                </div>
                <div className="AboutBrief-culture">
                    <div className="culture-title">
                        <div>
                            COMPANY <span>CULTURE</span>
                        </div>
                        <div>
                            公司文化
                        </div>
                    </div>
                    <div className="content">
                        <div className="left">
                            <img src={AboutBriefImg03} alt=""/>
                        </div>
                        <div className="right">
                            <div className="item">
                                <div className="title">
                                    — 经营理念
                                </div>
                                <div className="text">
                                    以人为本，诚信经营
                                </div>
                            </div>
                            <div className="item">
                                <div className="title">
                                    — 公司使命
                                </div>
                                <div className="text">
                                    构建综合运输网络和集货配送物流体系，做物流行业网络货运服务的现代化物流科技公司
                                </div>
                            </div>
                            <div className="item">
                                <div className="title">
                                    — 服务目标
                                </div>
                                <div className="text">
                                    将客户的需求永远放在第1位、让客户满意是我们的最终目的、专业、高效、安全、快捷、诚信。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AboutBrief;
